import EditFrame from './EditFrame';

export { type EditFrameProps } from './EditFrame';
export default EditFrame;
